
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/wnba-basketball-analysis",
      function () {
        return require("private-next-pages/blog/wnba-basketball-analysis.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/wnba-basketball-analysis"])
      });
    }
  